module.exports = __webpack_public_path__ + "static/media/image_78.2867b424.png";